'use strict';

frontendApp.factory('ThemeService', ['$rootScope', '$log', '$window', 'ConfigService', 'HttpService', function ($rootScope, $log, $window, ConfigService, HttpService) {

  var defaultTheme = {
    'name': 'Folio - Big Data eDiscovery',
    'firstParty': true,
    'largeLogo': 'https://iio-assets.s3.us-east-1.amazonaws.com/theme/default/FolioPoweredByRectangle.png',
    'headerLogo': 'https://s3.amazonaws.com/iio-assets/theme/default/FolioWhiteLogoRectangle.svg',
    'footerLogo': '',
    'backgroundColor': '#ffffff',
    'textColor': '#0e1111',
    'navBackgroundColor': '#18263B',
    'navTextColor': '#ffffff',
    'linkColor': '#3a547c',
    'messageType': null,
    'message': null
  };

  var stagingTheme = {
    ...defaultTheme,
    'name': 'Staging - Folio - Big Data eDiscovery',
    'navBackgroundColor': '#18263B',
  };

    var singaporeTheme = {
    ...defaultTheme,
    'name': 'Singapore - Folio - Big Data eDiscovery',
    'navBackgroundColor': '#002b63',
  };

    var greenDeployTheme = {
    ...defaultTheme,
    'name': 'Green - Folio - Big Data eDiscovery',
    'navBackgroundColor': '#006315',
  };

  var govDeployTheme = {
    ...defaultTheme,
    'name': 'Gov - Folio - Big Data eDiscovery',
    'navBackgroundColor': '#006315',
  };

  var _service = {
    theme: {}
  };

  var hasTheme = function () {
    return !_.isEmpty(_service.theme);
  };

  _service.EVENTS = {
    THEME_CHANGED: 'ThemeService:THEME_CHANGED'
  };

  _service.setCurrentTheme = function (theme) {
    $log.log("Setting theme", theme);
    _service.theme = theme;
    $rootScope.$broadcast(_service.EVENTS.THEME_CHANGED, theme);
  };

  _service.getCurrentTheme = function (callback) {
    return _service.theme;
    // var deferred = $q.defer();
    // var promise = deferred.promise;
    // var theme;

    // promise.then(function(theme) {
    //     if (callback) callback(theme);
    // });

    // if (hasTheme()) {
    //     deferred.resolve(_service.theme);
    // } else {
    //     _service.findThemeForSubdomain(function(theme) {
    //         deferred.resolve(theme);
    //     });
    // }

    // return promise;
  };

  _service.findThemeForSubdomain = function (callback) {
    var hostName = $window.location.hostname;
    var hostParts = hostName.split(".accessid.legal");
    var subdomain = hostParts[0].split(".")[0];

    console.log('Subdomain: ' + subdomain);

    const defaultThemeSubdomains = ['folio'];

    const stagingThemeSubdomains = ['staging', 'app.staging', 'app-staging', 'localhost'];

    const singaporeThemeSubdomains = ['app-sg'];

    const greenDeployThemeSubdomains = ['app-temp', 'temp'];

    const govDeployThemeSubdomains = ['app-gov', 'gov', 'cl04'];

    if (defaultThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(defaultTheme);
      if (callback) callback(defaultTheme);
    } else if (stagingThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(stagingTheme);
      if (callback) callback(stagingTheme);
    } else if (singaporeThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(singaporeTheme);
      if (callback) callback(singaporeTheme);
    } else if (greenDeployThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(greenDeployTheme);
      if (callback) callback(greenDeployTheme);
    } else if (govDeployThemeSubdomains.includes(subdomain)) {
      _service.setCurrentTheme(govDeployTheme);
      if (callback) callback(govDeployTheme);
    } else {
      HttpService.$http({
        method: 'GET',
        url: ConfigService.getServerBaseUrl() + '/organization/theme/' + subdomain
      }).success(function (response, status) {
        if (response.name == null) {
          _service.setCurrentTheme(defaultTheme);
          if (callback) callback(defaultTheme);
        } else {
          _service.setCurrentTheme(response);
          if (callback) callback(response);
        }
      }).error(function (data, status) {
        _service.setCurrentTheme(defaultTheme);
        if (callback) callback();
        $log.error("Unable to fetch theme");
      });
    }
  };

  return _service;
}]);

